import { useQuery } from '@tanstack/react-query';
import { getSharedDocuments } from '../api/shared-documents.api';

export const useSharedDocumentsListInit = ({ todayDateStr, isProjectOpen = false }: { todayDateStr: string; isProjectOpen?: boolean }) => {
	const {
		data: documentAccesses,
		error,
		isPending,
		isLoading,
		isError,
	} = useQuery({
		queryKey: ['GET_SHARED_PROJECT_DOCUMENTS_LIST'],
		queryFn: () => getSharedDocuments(todayDateStr),
		enabled: isProjectOpen,
		refetchOnWindowFocus: true,
	});

	return {
		documentAccesses,
		error,
		isPending,
		isLoading,
		isError,
	};
};
